import { z } from 'zod';

export const schemaTrackingObjectPart = z.object({
    adcref: z.string().optional(),
    adviser: z.string().optional(),
    advisor: z.string().optional(),
    agent: z.string().optional(),
    bid: z.string().optional(),
    bucket: z.string().optional(),
    consentString: z.string().optional(),
    directPartnerClickId: z.string().optional(),
    directPartnerId: z.string().optional(),
    directPartnerSourceId: z.string().optional(),
    directPartnerSubSourceId: z.string().optional(),
    domain: z.string().optional(),
    entryUri: z.string().optional(),
    fbc: z.string().optional(),
    fbclid: z.string().optional(),
    fbp: z.string().optional(),
    formType: z.string().optional(),
    fpid: z.string().optional(),
    ga_cid: z.string().optional(),
    gclid: z.string().optional(),
    optout_adcell: z.string().optional(),
    optout_facebook: z.string().optional(),
    optout_GA: z.string().optional(),
    optout_pinterest: z.string().optional(),
    optout_taboola: z.string().optional(),
    pid: z.string().optional(),
    referer: z.string().optional(),
    sessionId: z.string().optional(),
    submissionType: z.string().optional(),
    tbclid: z.string().optional(),
    team: z.string().optional(),
    uri: z.string().optional(),
    userAgent: z.string().optional(),
});

export const schemaTracking = schemaTrackingObjectPart.passthrough().nullish().default({});

export type SchemaTracking = z.infer<typeof schemaTracking>;
